

export function setOptionsViewArray(fieldslength: any){
    let result = [];
    for (let i = 0; i < fieldslength; i++) {
        result.push(false);
    }
    return result;
}